var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.03 0.7392h7.244v6.831m-12.8-5.099h-9.744v20.79h20.41v-10.39m2.136-12.13c-4.832 4.784-9.664 9.568-14.5 14.35",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.465
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitUs);
export default __webpack_public_path__ + "static/media/visit-us.b87274a2b17b3b7f68daf54ee8d8d01c.svg";
export { ForwardRef as ReactComponent };